import { ReactNode } from 'react';

import ErrorView from 'view/components/ErrorView/ErrorView';

import { useError } from '../error';

import PreloginView from './PreloginView';
import usePreloginPlugins from './usePreloginPlugins';

type PreloginWrapperProps = {
  children: ReactNode;
};

const PreloginWrapper = ({ children }: PreloginWrapperProps) => {
  const initialized = usePreloginPlugins();

  const { main: error } = useError();
  if (!initialized) {
    return error ? <ErrorView {...error} /> : <PreloginView />;
  }

  return children;
};

export default PreloginWrapper;
